import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const ATTACHMENT_ROW_COUNT: number = 3;

const FieldSkeleton = ({
  labelWidth,
  inputHeight = '3.6rem',
}: {
  labelWidth: string;
  inputHeight?: string;
}) => (
  <div>
    <div style={{ marginBottom: '0.5rem' }}>
      <Skeleton variant="text" width={labelWidth} />
    </div>
    <Skeleton variant="rect" width="100%" height={inputHeight} />
  </div>
);

const AttachmentRowSkeleton = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
    <Skeleton variant="rect" width="4rem" height="4rem" />
    <Skeleton variant="text" width="60%" />
  </div>
);

const AnnouncementViewSkeleton = () => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '2.5rem',
    }}
  >
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <FieldSkeleton labelWidth="9rem" />

      <div style={{ display: 'flex', gap: '1.5rem' }}>
        <Skeleton variant="text" width="6rem" />
        <Skeleton variant="text" width="6rem" />
      </div>

      <FieldSkeleton labelWidth="6rem" />
      <FieldSkeleton labelWidth="4rem" />
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <FieldSkeleton labelWidth="4rem" />

      <div>
        <div style={{ marginBottom: '0.5rem' }}>
          <Skeleton variant="text" width="7rem" />
        </div>
        <Skeleton variant="rect" width="100%" height="8rem" />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {Array.from({ length: ATTACHMENT_ROW_COUNT }, (_, index: number) => (
          <AttachmentRowSkeleton
            key={`announcement-view-attachment-skeleton-${index}`}
          />
        ))}
      </div>
    </div>
  </div>
);

export default AnnouncementViewSkeleton;
